import Watchlist from './Watchlist.page';

export default Watchlist;